"use strict";
export * from "./components";
export * from "./plugin";
export default vueWrapper;
function vueWrapper() {
    return "Hello from vueWrapper";
}
//# sourceMappingURL=index.js.map